import React from 'react'
import {connect} from 'react-redux'
import {List} from 'immutable'

import {
  CONVERSATION_TYPES
} from '../shared/config/constants'

import showModal from '../shared/data/actions/show_modal'

import GroupChatsSeeAllLink from '../shared/group_chats_see_all_link'
import ChatListSegment from './chat_list_segment'

class ChatListGroupChatSegment extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}

    this.onGroupChatFooterClick = this.onGroupChatFooterClick.bind(this)
  }

  componentWillMount () {
    this.setGroupChats(this.props.globalGroupChats, this.props.bookmarkedGroupChats)
  }

  componentWillReceiveProps (nextProps) {
    const {globalGroupChats: globals, bookmarkedGroupChats: bookmarkeds} = this.props
    const {globalGroupChats: nextGlobals, bookmarkedGroupChats: nextBookmarkeds} = nextProps

    if (globals !== nextGlobals || bookmarkeds !== nextBookmarkeds) {
      this.setGroupChats(nextGlobals, nextBookmarkeds)
    }
  }

  setGroupChats (globals, bookmarkeds) {
    const groupChats = globals.concat(bookmarkeds)

    this.setState({groupChats})
  }

  onGroupChatFooterClick (e) {
    if (e && e.preventDefault) e.preventDefault()

    this.props.showModal({type: 'groupChats', props: {}})
  }

  renderGroupFooter () {
    return (
      <GroupChatsSeeAllLink classes='chat-list-footer-action'>
        SEE ALL CHAT ROOMS
      </GroupChatsSeeAllLink>
    )
  }

  render () {
    return (
      <ChatListSegment
        label={this.props.title}
        footer={this.renderGroupFooter()}
        conversationType={CONVERSATION_TYPES.GROUP}
        shouldShowUnreadMessageCount={true}
        list={this.state.groupChats}/>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    title: state.getIn(['chatSettings', 'segments', 'groups', 'title']),
    globalGroupChats: state.getIn(['chatListView', 'segments', 'groups', 'list'], List()),
    bookmarkedGroupChats: state.getIn(['groups', '_bookmarks', 'list'], List())
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showModal: (modal) => dispatch(showModal(modal))
  }
}

const ChatListGroupChatSegmentContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ChatListGroupChatSegment)

export default ChatListGroupChatSegmentContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/chat_list_group_chat_segment.js
 **/